// extracted by mini-css-extract-plugin
export default {"cardContainer":"PregledKlijenata_cardContainer__-c56B","searchContainer":"PregledKlijenata_searchContainer__WYmMR"};